/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Word_UpInputs */



/**
* | output |
* | --- |
* | "Move a single word up to the previous line" |
*
* @param {Shortcut_Keys_Desc_Move_Word_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_word_up = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Word_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Word_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer un mot vers la ligne precedente")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebe ein einzelnes Wort in die vorherige Zeile.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta una singola parola alla riga precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместитесь на одно слово вверх, на предыдущую строку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover una sola palabra a la línea anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将一个单词上移到上一行。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1つの単語を前の行に移動する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक शब्द को पिछली पंक्ति में ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mova uma única palavra para a linha anterior.")
	return /** @type {LocalizedString} */ ("Move a single word up to the previous line")
});